export default "__VITE_ASSET__Caaqfcmb__"